import { PAYMENT_METHOD } from "./PaymentMethod";
import { REDEMPTION_METHOD } from './RedemptionMethodTypes';

export const PAYMENT_DOCUMENT_TEMPLATE = {
  [PAYMENT_METHOD.None]: 'None',
  [PAYMENT_METHOD.CreditCard]: 'OrderConfirmationByCreditCard',
  [PAYMENT_METHOD.CryptoCurrency]: 'OrderConfirmationByCryptoCurrency',
  [PAYMENT_METHOD.BankTransfer]: 'OrderBankTransferInvoice' 
};

export const REDEMPTION_DOCUMENT_TEMPLATE = {
  [REDEMPTION_METHOD.Bank]: 'RedemptionConfirmationByBankTransfer',
  [REDEMPTION_METHOD.Bitcoin]: 'RedemptionConfirmationByBitcoinPayment',
  [REDEMPTION_METHOD.ERC20]: 'RedemptionConfirmationByEthereumToken',
  [REDEMPTION_METHOD.Ethereum]: 'RedemptionConfirmationByEthereum',
  [REDEMPTION_METHOD.InternalNetwork]: 'RedemptionConfirmationByInternalNetwork',
  [REDEMPTION_METHOD.Physical]: 'RedemptionConfirmationByPhysicalDelivery'
};
